import { z } from "zod";

const stream = z.string().min(1).max(128);
export const EmailControlMutation = z.object({
  action_id: z.uuid(), stream: stream.default("*"),
  expected_version: z.number().int().min(0).max(2_147_483_646),
  reason: z.string().trim().min(1).max(500),
}).strict();
export type EmailControlMutation = z.infer<typeof EmailControlMutation>;
export const EmailControlStatusQuery = z.object({ stream: stream.default("*") }).strict();
export const EmailControlHistoryQuery = z.object({
  stream: stream.default("*"), limit: z.coerce.number().int().min(1).max(100).default(50),
  cursor: z.string().min(1).max(512).optional(),
}).strict();
export const EmailControlRow = z.object({
  stream, authority: z.enum(["admin", "service"]), paused: z.boolean(), version: z.number().int(), updated_at: z.string(),
  reason: z.string().optional(), actor_kind: z.enum(["user", "api_key"]).optional(), actor_id: z.uuid().optional(),
});
export const EmailControlStatus = z.object({
  client_id: z.uuid(), stream, paused: z.boolean(),
  versions: z.object({ admin: z.number().int(), service: z.number().int() }),
  controls: z.array(EmailControlRow),
});
export type EmailControlStatus = z.infer<typeof EmailControlStatus>;
export const EmailControlResponse = EmailControlStatus.extend({ action_id: z.uuid(), version: z.number().int(), replayed: z.boolean() });
export const EmailControlHistory = z.object({
  items: z.array(z.object({
    action_id: z.uuid(), stream, authority: z.enum(["admin", "service"]), operation: z.enum(["pause", "resume"]), created_at: z.string(),
    reason: z.string().optional(), actor_kind: z.enum(["user", "api_key"]).optional(), actor_id: z.uuid().optional(),
  })), next_cursor: z.string().nullable(),
});
